import { DisplayedTicketRegistrationForms } from 'app/components/ParticipantsInformation/ParticipantsInformation';
import { EventFieldType } from 'types/EventField';
import { OrderStatusType } from 'utils/orderStatuses';

export interface OrderData {
  uuid: string;
  status: OrderStatusType;
  pendingReason: string | null;
  placedAt: string;
  createdAt: string;
  numberOfTickets: number;
  hasAddonsOrTopUps: boolean;
  hasNFT: boolean;
  dueDays: number;
  tickets: DisplayedTicketRegistrationForms[];
  invoice: string;
  order_total: {
    currency: string;
    net_price: number;
    tax_amount: number;
  };
  customer_info: {
    email: string;
    name: string;
  };
}

export interface EventData {
  id: string;
  id_seller: string;
  name: string;
  timeInterval: {
    startsAt: string;
    endsAt: string;
  };
  location: string;
  dateTimeFormat: {
    dateFormat: string;
    timeFormat: string;
    timezone: string;
  };
  checkoutConfiguration: {
    orderConfirmationPageType: string;
    orderConfirmationPageText: string;
    orderConfirmationPageUrl: string | null;
    displayTickets: boolean;
  };
  registrationform: EventFieldType[];
  gtm_code: string;
  currency: string;
  hasSeatingChart: boolean;
}

export const initialEventData = {
  id: '',
  id_seller: '',
  name: '',
  timeInterval: {
    startsAt: '',
    endsAt: '',
  },
  location: '',
  dateTimeFormat: {
    timezone: '',
    dateFormat: '',
    timeFormat: '',
  },
  checkoutConfiguration: {
    orderConfirmationPageType: '',
    orderConfirmationPageText: '',
    orderConfirmationPageUrl: '',
    displayTickets: true,
  },
  registrationform: [],
  gtm_code: '',
  currency: '',
  hasSeatingChart: false,
};
